<template>
  <div class="abonements-page">
    <LandingNavbar :solid="true" />

    <section class="abonements-hero d-flex flex-column align-center text-center px-4">
      <span class="section-label">Abonements</span>
      <h1>Viss, kas nepieciešams<br class="d-none d-sm-inline"> mācību procesam</h1>
      <p class="hero-subtitle mt-4">
        Labākā izvēle jūsu skolai - piekļuve visam saturam skolotājiem, skolēniem un viņu vecākiem.
      </p>
    </section>

    <section class="abonements-content d-flex justify-center px-4">
      <div class="page-content w-100">
        <span class="section-label">Saturs</span>
        <h2 class="section-title">Kas ietilpst abonementā?</h2>

        <div class="feature-card">
          <span class="feature-pill">Mācību gada abonements</span>
          <h3 class="feature-heading mt-4">Izglītības iestādes abonements</h3>
          <div class="feature-columns d-flex flex-column flex-sm-row">
            <ul class="feature-list">
              <li v-for="item in featuresLeft" :key="item" class="d-flex align-start">
                <v-icon class="feature-check" icon="fa-solid fa-circle-check" />
                <span>{{ item }}</span>
              </li>
            </ul>
            <ul class="feature-list">
              <li v-for="item in featuresRight" :key="item" class="d-flex align-start">
                <v-icon class="feature-check" icon="fa-solid fa-circle-check" />
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="abonements-price d-flex justify-center px-4">
      <div class="page-content w-100">
        <span class="section-label">Cena</span>
        <h2 class="section-title">12 EUR gadā par vienu skolēnu, skolotājiem un vecākiem bez maksas.</h2>

        <div class="price-cards d-flex flex-column flex-sm-row">
          <div v-for="card in priceCards" :key="card.title" class="price-card">
            <span class="price-emoji">{{ card.emoji }}</span>
            <h3 class="price-card-title mt-3">{{ card.title }}</h3>
            <p class="price-card-text mt-2">{{ card.text }}</p>
          </div>
        </div>

        <LandingStats class="price-stats" />
      </div>
    </section>

    <section class="abonements-contact d-flex justify-center px-4">
      <div class="page-content w-100 d-flex flex-column flex-md-row">
        <div class="contact-intro pr-md-8">
          <span class="section-label">Sazināties</span>
          <h2 class="section-title">Piesakies un saņem piedāvājumu savai skolai</h2>
          <p class="contact-text">
            Zvaniet, rakstiet vai aizpildiet pieteikuma formu! Mūsu speciālisti ar Jums sazināsies 1-2 darba dienu laikā!
          </p>
          <div class="contact-items mt-6">
            <div v-for="contact in contacts" :key="contact.label" class="contact-item d-flex align-center">
              <span class="contact-icon d-flex align-center justify-center">
                <v-icon :icon="contact.icon" />
              </span>
              <div class="ml-4">
                <div class="contact-label">{{ contact.label }}</div>
                <div class="contact-value">{{ contact.value }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="contact-form-wrapper">
          <div
            id="abonements-webform"
            class="pipedriveWebForms w-100"
            data-pd-webforms="https://webforms.pipedrive.com/f/1DZASij4sH4dD4cBBKHqGF7XkrADumfWBEKJErF6hJsjlZSM7mz5uKtTF698D3kHx"
          >
            <iframe
              src="https://webforms.pipedrive.com/f/1DZASij4sH4dD4cBBKHqGF7XkrADumfWBEKJErF6hJsjlZSM7mz5uKtTF698D3kHx?embeded=1&amp;uuid=abonements-webform"
              name="https://soma.lv/-abonements-webform"
              scrolling="no"
              title="Web Forms"
              style="height: 743px;"
              class="w-100"
            >
            </iframe>
          </div>
        </div>
      </div>
    </section>

    <LandingFooter />
  </div>
</template>

<script lang="ts">
import LandingFooter from "~/components/home-page/landing/LandingFooter.vue"
import LandingNavbar from "~/components/home-page/landing/LandingNavbar.vue"
import LandingStats from "~/components/home-page/landing/LandingStats.vue"

export default {
  components: { LandingFooter, LandingNavbar, LandingStats },

  setup() {
    definePageMeta({ layout: false })
  },

  data() {
    return {
      featuresLeft: [
        "Pieeja visiem skolotājiem, skolēniem un viņu vecākiem",
        "E-grāmatas un darba lapas",
        "Testi un to veidošana",
        "Integrācija ar skolvadības sistēmām: E-klase un MyKoob",
        "Skolēnu rezultātu atskaites un to eksports uz E-klasi",
      ],
      featuresRight: [
        "Viedgrāmatas visiem 16 mācību priekšmetiem",
        "Pārbaudes darbi",
        "Tematiskie plāni stundu sagatavošanai",
        "Viedstundu, testu un darba lapu pārvaldīšana",
        "Pieejams saturs 24/7 no jebkuras ierīces",
      ],
      priceCards: [
        { emoji: "🏫", title: "Skolas lielums", text: "Cena tiek aprēķināta no skolēnu skaita mācību iestādē neatkarīgi no tās lieluma." },
        { emoji: "📅", title: "Mācību gada abonements", text: "Abonements tiek slēgts uz vienu mācību gadu. Mācību gada laikā reģistrētie lietotāji brīvi piekļūst visam saturam." },
        { emoji: "⚡", title: "Priekšmetu izvēle", text: "Pieejami 16 mācību priekšmeti. Abonements ietver piekļuvi visiem priekšmetiem — no matemātikas līdz pat vācu valodai." },
      ],
      contacts: [
        { icon: "fa-light fa-phone", label: "Tālrunis", value: "+371 67801787" },
        { icon: "fa-light fa-envelope", label: "E-pasts", value: "soma@lielvards.lv" },
      ],
    }
  },

  mounted() {
    window.hideBeacon()
  },

  beforeUnmount() {
    window.unhideBeacon()
  },
}
</script>

<style scoped lang="sass">
@use "~/assets/css/vuetify/settings" as *

.abonements-page
  display: flex
  flex-direction: column
  min-height: 100vh

.section-label
  display: block
  color: rgb(var(--v-theme-landingGreen))
  font-weight: 800
  font-size: 0.875rem
  letter-spacing: 0.08rem
  text-transform: uppercase

.section-title
  font-size: 2rem
  font-weight: 800
  line-height: 1.2
  color: rgb(var(--v-theme-blackActive))
  margin: 0.5rem 0 2rem

.abonements-hero
  background-color: rgb(var(--v-theme-tertiaryContainer))
  border-bottom-left-radius: 40px
  border-bottom-right-radius: 40px
  padding-top: 8rem
  padding-bottom: 4rem
  .section-label
    margin-bottom: 1rem
  h1
    font-size: 2.875rem
    font-weight: 800
    color: rgb(var(--v-theme-blackActive))
    line-height: 3.1rem
  .hero-subtitle
    font-size: 1.125rem
    color: rgb(var(--v-theme-blackActive))

.abonements-content
  padding-top: 4rem
  padding-bottom: 4rem

.feature-card
  border: 2px solid color-mix(in srgb, rgb(var(--v-theme-landingGreen)) 88%, white)
  border-radius: 20px
  padding: 2rem
  .feature-pill
    display: inline-block
    background-color: rgb(var(--v-theme-landingGreen))
    color: white
    font-weight: 800
    font-size: 0.75rem
    letter-spacing: 0.06rem
    text-transform: uppercase
    padding: 0.35rem 1rem
    border-radius: 8px
  .feature-heading
    font-size: 1.5rem
    font-weight: 800
    color: rgb(var(--v-theme-blackActive))
  .feature-columns
    gap: 0 3rem
    margin-top: 1.5rem
  .feature-list
    flex: 1
    list-style: none
    padding: 0
    margin: 0
    li
      margin-bottom: 1rem
      font-size: 1rem
      color: rgb(var(--v-theme-blackActive))
    .feature-check
      color: rgb(var(--v-theme-landingGreen))
      font-size: 1.1rem
      margin-right: 0.75rem
      margin-top: 0.1rem

.abonements-price
  background-color: rgb(var(--v-theme-yellowBack))
  padding-top: 4rem
  padding-bottom: 4rem

.price-cards
  gap: 1.5rem
  .price-card
    flex: 1
    background-color: white
    border-radius: 16px
    padding: 1.75rem
    box-shadow: 0 10px 24px rgba(38, 38, 38, 0.05)
    .price-emoji
      font-size: 1.75rem
    .price-card-title
      font-size: 1.25rem
      font-weight: 800
      color: rgb(var(--v-theme-blackActive))
    .price-card-text
      font-size: 1rem
      color: rgb(var(--v-theme-blackActive))

.abonements-price .price-stats
  margin-top: 2rem
  padding: 0 !important
  background-color: transparent
  :deep(.stats-card)
    background-color: white
    border: none
    box-shadow: 0 10px 24px rgba(38, 38, 38, 0.05)

.abonements-contact
  padding-top: 4rem
  padding-bottom: 5rem
  .contact-text
    font-size: 1.05rem
    color: rgb(var(--v-theme-blackActive))
    margin-top: 1rem

.contact-intro, .contact-form-wrapper
  width: 100%

@media #{map-get($display-breakpoints, 'md-and-up')}
  .contact-intro, .contact-form-wrapper
    width: 50%

@media #{map-get($display-breakpoints, 'xs')}
  .hero-subtitle, .contact-text, .price-card-text, .feature-list li
    line-height: 1.3

.contact-items
  .contact-item
    margin-bottom: 1.25rem
  .contact-icon
    width: 2.75rem
    height: 2.75rem
    border-radius: 12px
    background-color: rgb(var(--v-theme-yellowBack))
    color: rgb(var(--v-theme-landingOrange))
    font-size: 1.1rem
  .contact-label
    font-weight: 800
    color: rgb(var(--v-theme-blackActive))
  .contact-value
    color: rgb(var(--v-theme-blackActive))

.contact-form-wrapper
  iframe
    border: none
</style>
